import React, { memo } from 'react';

const WarningIcon: React.FC = () => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99942 17.01C1.45942 17.01 0.499418 15.34 1.26942 14.01L8.79942 1C9.56942 -0.329998 11.4894 -0.329998 12.2594 1L19.7894 14.01C20.5594 15.34 19.5994 17.01 18.0594 17.01H2.99942ZM18.06 15.01L10.53 2L3 15.01H18.06Z"
      fill="#AD5F00"
    />
    <path
      d="M9.5293 7.01001V10C9.5293 10.55 9.9793 11 10.5293 11V11C11.0793 11 11.5293 10.55 11.5293 10V7.01001C11.5293 6.46001 11.0793 6.01001 10.5293 6.01001V6.01001C9.9793 6.01001 9.5293 6.46001 9.5293 7.01001Z"
      fill="#AD5F00"
    />
    <circle cx="10.5293" cy="13.01" r="1" fill="#AD5F00" />
  </svg>
);

export default memo(WarningIcon);
